import React, { useEffect, useRef } from 'react';
import { HERO_IMAGE_URL } from '../utils/headMeta';
interface FloatingMockupProps {
  alt: string;
  /** Clases de tamaño de la imagen (ancho máximo, etc.). */
  className?: string;
  sizes?: string;
  /** Sólo el mockup del hero es LCP. */
  priority?: boolean;
  /** Parallax muy leve al hacer scroll (se ignora en mobile). */
  parallax?: boolean;
}
const IMG_WIDTH = 1254;
const IMG_HEIGHT = 1254;
/** Desplazamiento máximo del parallax, en píxeles. */
const PARALLAX_RANGE = 14;

/**
 * Mockup oficial (PNG con fondo transparente) presentado como pieza flotante:
 * entrada suave, respiración vertical lenta y sombra proyectada. El parallax
 * sólo se activa en pantallas grandes y con animaciones habilitadas.
 */
export function FloatingMockup({
  alt,
  className = '',
  sizes,
  priority = false,
  parallax = false
}: FloatingMockupProps) {
  const wrapperRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!parallax) return;
    const node = wrapperRef.current;
    if (!node) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wide = window.matchMedia('(min-width: 1024px)');
    if (reduced.matches || !wide.matches) return;
    let frame = 0;
    const update = () => {
      frame = 0;
      const rect = node.getBoundingClientRect();
      // -1 (debajo del viewport) → 1 (arriba); se traduce en un giro suave.
      const progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
      const clamped = Math.max(-1, Math.min(1, progress));
      node.style.transform = `translate3d(0, ${(-clamped * PARALLAX_RANGE).toFixed(2)}px, 0)`;
    };
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(update);
    };
    update();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      node.style.transform = '';
    };
  }, [parallax]);
  return <div ref={wrapperRef} className="will-change-transform" data-id="element-76" data-mp="3unfkwezgyorl">
      <img src={HERO_IMAGE_URL} alt={alt} width={IMG_WIDTH} height={IMG_HEIGHT} sizes={sizes} decoding="async" {...priority ? {
      fetchPriority: 'high' as const
    } : {
      loading: 'lazy' as const
    }} style={{
      aspectRatio: `${IMG_WIDTH} / ${IMG_HEIGHT}`
    }} className={`mockup-float mx-auto block h-auto w-full object-contain ${className}`} data-id="element-77" data-mp="3fzkskzpdimf1" />
    </div>;
}